import {
  type ReconciliationItem,
  type StaleUpstreamKind,
  changedUpstreamText,
} from '@sigora/domain';

/**
 * What a step says while its document is brought up to date with a change above it, once it has
 * been, and on the items it changed, in one place for every step that reconciles. `document` is the
 * step's own noun: "guide".
 */

/** Over the earlier version while a reconciliation is asked for or waited on. */
export const BEFORE_YOUR_CHANGE = 'Before your change';

export const reconcilePendingText = (document: string, kinds: readonly StaleUpstreamKind[]) =>
  `Sigora is updating your ${document} for ${changedUpstreamText(kinds)}…`;

export const reconcileOverdueText = (document: string) =>
  `Sigora is taking longer than it should to update your ${document}.`;

export const reconcileFailedText = (document: string) =>
  `Sigora couldn’t update your ${document}. Try again.`;

export const reconciledText = (document: string, kinds: readonly StaleUpstreamKind[]) =>
  `Sigora updated this ${document} for ${changedUpstreamText(kinds)}. What changed is marked below.`;

export const reconciledUnchangedText = (kinds: readonly StaleUpstreamKind[]) =>
  `Sigora checked this against ${changedUpstreamText(kinds)}. Nothing needed to change. Press Continue to approve it.`;

/** The heading over what a reconciliation removed. */
export const RECONCILED_REMOVED_HEADING = 'Removed:';

/** The tag on an item a reconciliation changed or added; shown until the step is approved. */
export const CHANGE_MARK_LABELS: Record<
  Exclude<ReconciliationItem['change'], 'removed'>,
  string
> = {
  changed: 'Changed',
  added: 'New',
};
